import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2196F3',
        secondary: '#757575',
        accent: '#82B1FF',
        error: '#FF5252',
        delete: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        add: '#4CAF50',
        warning: '#FFC107',
        lightGrey: '#d3d3d3',
        loading: '#2196F3'
      }
    }
  }
})
